import React, { Component } from 'react';

import { notification, Button, Divider, Modal, Row, Col } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import { imprimirCasoViolencia } from '../../common/funciones/imprimirCasoViolencia';
import Evaluacion from './Evaluacion';
import VisorPersona from './VisorPersona';
import TablaDocumentos from './TablaDocumentos';

import getCasoViolenciaPorId from '../../../graphql/querys/violenciaGenero/getCasoViolenciaPorId.graphql';
import getCasosViolencia from '../../../graphql/querys/violenciaGenero/getCasosViolencia.graphql';
import deleteCasoViolencia from '../../../graphql/mutations/violenciaGenero/deleteCasoViolencia.graphql';
import deleteMedida from '../../../graphql/mutations/violenciaGenero/deleteMedida.graphql';
import editarAgresor from '../../../graphql/mutations/violenciaGenero/editarAgresor.graphql';
import confirmarDocumento from '../../../graphql/mutations/common/confirmarDocumento.graphql';
import updatePersonaPorId from '../../../graphql/mutations/persona/updatePersonaPorId.graphql';

import enviarDocumentoPorEmail from '../../../graphql/mutations/common/enviarDocumentoPorEmail.graphql';

import ModalMandarEmail from './ModalMandarEmail';
import ModalVisorEmail from '../../common/ModalVisorEmail';
import { errorService } from '../../../graphql/utils/utils';
import FormPersona from '../../tramites/formularios/FormPersona';
import ModalUploader from './documentos/ModalUploader';

import { verPdf } from '../../common/funciones/verPdf';

const confirm = Modal.confirm;
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(deleteCasoViolencia, {
    name: 'deleteCasoViolencia',
    options: {
      refetchQueries: [{ query: getCasosViolencia }],
    },
  }),
  graphql(updatePersonaPorId, {
    name: 'updatePersonaPorId',
  }),
  graphql(editarAgresor, {
    name: 'editarAgresor',
  }),
  graphql(confirmarDocumento, {
    name: 'confirmarDocumento',
  }),
  graphql(deleteMedida, {
    name: 'deleteMedida',
  }),
  graphql(enviarDocumentoPorEmail, {
    name: 'enviarDocumentoPorEmail',
  }),
  graphql(getCasoViolenciaPorId, {
    options: props => ({
      variables: {
        _id: props.match.params.id,
      },
      fetchPolicy: 'network-only',
    }),
  })
)
class VerCaso extends Component {
  constructor(props) {
    super(props);

    this.state = {
      caso: {},
      loading: true,
      visibleModalMandarEmail: false,
      visibleModalVisorEmail: false,
      visibleModalUploader: false,
      idDocumento: null,
      editarAgresor: false,
      editarPersona: false,
    };
  }

  mostrarModalUploader = () => {
    this.setState({
      visibleModalUploader: true,
    });
  };

  ocultarModalUploader = () => {
    this.setState({
      visibleModalUploader: false,
      contraventorMostrar: {},
    });
  };

  componentDidMount() {
    // console.log("Component did Mount");
    if (this.props.match.params) {
      let _id = this.props.match.params.id;

      if (_id) {
        this.props.client
          .query({
            query: getCasoViolenciaPorId,
            variables: { _id: _id },
          })
          .then(res => {
            let caso = res.data.getCasoViolenciaPorId;
            let fechaVictima;

            if (caso.victima.fecha_nacimiento) {
              fechaVictima = moment(caso.victima.fecha_nacimiento).format(
                'DD/MM/YYYY'
              );
            }

            let datos = {
              ...caso,
              victima: {
                ...caso.victima,
                fecha_nacimiento: fechaVictima,
              },
            };

            this.setState({
              ...this.state,
              caso: datos,
              loading: false,
            });
          })
          .catch(err => {
            console.log(
              'Error en la obtencion de los datos completos del caso de violencia'
            );
            console.log(err);
          });
      }
    }
  }

  onImprimir = caso => {
    imprimirCasoViolencia(caso);
  };

  onDelete = id => {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar el caso de violencia con id ", id);

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este caso de violencia de genero?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteCasoViolencia({
            variables: { _id: id },
          })
          .then(res => {
            // console.log("La respuesta del delete fue....");
            // console.log(res);

            let id = res.data.deleteCasoViolencia;

            if (id) {
              notification.warning({
                message: 'Caso de Violencia eliminado',
                description:
                  'Se ha eliminado el caso de violencia exitosamente',
              });
            }
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el caso de violencia de genero'
            );
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion el caso de violencia de genero ',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };
  eliminar = idDocumento => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta medida del caso de violencia?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteMedida({
            variables: { _id: idDocumento },
            refetchQueries: [
              {
                query: getCasoViolenciaPorId,
                variables: {
                  _id: yo.props.data.getCasoViolenciaPorId._id,
                },
              },
            ],
          })
          .then(res => {
            console.log('La respuesta del delete fue....');
            console.log(res);

            let id = res.data.deleteDocumento;

            if (id) {
              notification.warning({
                message: 'Medida eliminada',
                description: 'Se ha eliminado la medida exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar la medida');
            console.log(err);

            errorService(err, {
              idDocumento,
            });

            Modal.error({
              title:
                'Error en la eliminacion de la medida del caso de violencia',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  onEditarAgresor = agresor => {
    this.setState({
      editarAgresor: true,
      agresor,
    });
  };

  // FUNCION PARA EDITAR VICTIMAS Y DENUNCIANTES
  onEditarPersona = persona => {
    this.setState({
      editarPersona: true,
      persona,
    });
  };

  onFinishEditarPersona = nuevaPersona => {
    this.props
      .updatePersonaPorId({
        variables: {
          _id: this.state.persona._id,
          nuevaPersona,
        },
      })
      .then(res => {
        console.log('res', res);
        if (res.data.updatePersonaPorId) {
          notification.success({
            message: 'Persona editada con exito',
            description: 'Se ha editado la persona exitosamente',
          });
        }
      })
      .catch(err => {
        console.log('error en la mutation', err);
      });

    this.setState({
      editarPersona: false,
    });
  };

  onFinishEditarAgresor = nuevoAgresor => {
    let _id = this.props.match.params.id;
    this.props
      .editarAgresor({
        variables: {
          _id,
          idAgresor: this.state.agresor._id,
          nuevoAgresor,
        },
        refetchQueries: [
          {
            query: getCasoViolenciaPorId,
            variables: {
              _id: this.props.data.getCasoViolenciaPorId._id,
            },
          },
        ],
      })
      .then(res => {
        if (res.data.editarAgresor) {
          notification.success({
            message: 'Agresor editado con exito',
            description: 'Se ha editado el agresor exitosamente',
          });
        }
      })
      .catch(err => {
        console.log('Error en la consulta: ', err);
      });

    this.setState({
      editarAgresor: false,
    });
  };

  mostrarModalMandarEmail = idDoc => {
    this.setState({
      visibleModalMandarEmail: true,
      idDocumento: idDoc,
    });
  };

  ocultarModalMandarEmail = () => {
    this.setState({
      visibleModalMandarEmail: false,
      idDocumento: null,
    });
  };

  mostrarModalVisorEmail = idDoc => {
    this.setState({
      visibleModalVisorEmail: true,
      idDocumento: idDoc,
    });
  };

  ocultarModalVisorEmail = () => {
    this.setState({
      visibleModalVisorEmail: false,
      idDocumento: null,
    });
  };

  confirmarDocumento = id => {
    this.setState({
      loadingConfirmarDocumento: true,
    });
    this.props
      .confirmarDocumento({
        variables: {
          _id: id,
        },
        refetchQueries: [
          {
            query: getCasoViolenciaPorId,
            variables: {
              _id: this.props.data.getCasoViolenciaPorId._id,
            },
          },
        ],
      })
      .then(res => {
        if (res.data.confirmarDocumento) {
          this.setState({
            loadingConfirmarDocumento: false,
          });
        }
      })
      .catch(err => {
        console.log('ERROR: ');
        console.log(err);
        this.setState({
          loadingConfirmarDocumento: false,
        });
        errorService(err, {
          _id: id,
        });
      });
  };

  volver = () => {
    // this.props.history.push('/contravenciones/expedientes');
    this.props.history.goBack();
  };

  render() {
    if (this.state.loading || this.props.data.loading) {
      return <Loading />;
    }

    let caso = this.props.data.getCasoViolenciaPorId;

    let medidas = caso.medidas;

    let victimaDenunciante =
      caso.denunciante.tipo_doc === caso.victima.tipo_doc &&
      caso.denunciante.num_doc === caso.victima.num_doc;

    return (
      <div style={{ margin: 25 }}>
        <Row>
          <Col span={6} offset={8}>
            <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
              <Icons.FileTextOutlined /> Caso de Violencia de Genero
            </h2>
          </Col>
          <Col span={9} offset={1}>
            <Button type="danger" onClick={this.volver}>
              <Icons.BackwardOutlined />
              Volver
            </Button>
          </Col>
        </Row>
        {!this.state.editarAgresor && !this.state.editarPersona ? (
          <div style={estiloContent}>
            <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
              <Col span={11} offset={1}>
                <h3>Fecha de Creacion:</h3>
              </Col>
              <Col span={11}>
                {caso.fecha
                  ? moment(caso.fecha).format('DD/MM/YYYY')
                  : 'SIN DATOS'}
              </Col>
            </Row>
            <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
              <Col span={11} offset={1}>
                <h3>Organismo:</h3>
              </Col>
              <Col span={11}>
                {caso.organismo ? caso.organismo.nombre : 'SIN DATOS'}
              </Col>
            </Row>
            <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
              <Col span={11} offset={1}>
                <h3>Numero del Caso:</h3>
              </Col>
              <Col span={11}>
                {caso && caso.numero ? caso.numero : 'SIN DATOS'}
              </Col>
            </Row>
            <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
              <Col span={11} offset={1}>
                <h3>Cantidad de Documentos Generados:</h3>
              </Col>
              <Col span={11}>
                {caso.medidas ? caso.medidas.length : 'SIN DATOS'}
              </Col>
            </Row>
            <Divider />
            <Row type={'flex'} justify={'center'}>
              <Col span={22} offset={1}>
                <VisorPersona
                  persona={this.state.caso.denunciante}
                  tipos={
                    victimaDenunciante
                      ? ['victima', 'denunciante']
                      : ['denunciante']
                  }
                  acciones={
                    <Button
                      type="primary"
                      onClick={() =>
                        this.onEditarPersona(this.state.caso.denunciante)
                      }
                    >
                      Editar
                    </Button>
                  }
                />

                {!victimaDenunciante && (
                  <VisorPersona
                    persona={this.state.caso.victima}
                    tipos={['victima']}
                    acciones={
                      <Button
                        type="primary"
                        onClick={() =>
                          this.onEditarPersona(this.state.caso.victima)
                        }
                      >
                        Editar
                      </Button>
                    }
                  />
                )}

                {_.map(this.state.caso.agresores, agresor => {
                  return (
                    <VisorPersona
                      key={agresor.num_doc}
                      persona={agresor}
                      tipos={['agresor']}
                      acciones={
                        <Button
                          type="primary"
                          onClick={() => this.onEditarAgresor(agresor)}
                        >
                          Editar
                        </Button>
                      }
                    />
                  );
                })}
              </Col>
            </Row>

            <Divider className="no-print" />

            <Row type={'flex'} justify={'center'}>
              <Col span={22} offset={1}>
                <Evaluacion
                  evaluacion={this.state.caso.evaluacion}
                  history={this.props.history}
                  match={this.props.match}
                />
              </Col>
            </Row>

            <Row type={'flex'} justify={'center'}>
              <Col span={22} offset={1}>
                <TablaDocumentos
                  documentos={medidas}
                  mostrarModalMandarEmail={this.mostrarModalMandarEmail}
                  mostrarModalVisorEmail={this.mostrarModalVisorEmail}
                  eliminarDocumento={this.eliminar}
                  total={medidas.length}
                  history={this.props.history}
                  verPdf={(base64, fileName) => verPdf(base64, fileName)}
                  confirmarDocumento={this.confirmarDocumento}
                />
              </Col>
            </Row>

            <ModalMandarEmail
              visibleModalMandarEmail={this.state.visibleModalMandarEmail}
              ocultarModalMandarEmail={this.ocultarModalMandarEmail}
              idDocumento={this.state.idDocumento}
            />

            <ModalVisorEmail
              id={this.state.idDocumento}
              visibleModalLogsEmail={this.state.visibleModalVisorEmail}
              ocultarModalLogsEmail={this.ocultarModalVisorEmail}
            />

            <ModalUploader
              mostrarModalUploader={this.state.visibleModalUploader}
              ocultarModalUploader={this.ocultarModalUploader}
              caso={caso}
              match={this.props.match}
            />

            <Divider className="no-print" />

            <Row>
              <Col span={16} offset={4}>
                <Button
                  type="primary"
                  icon={<Icons.EditOutlined />}
                  onClick={() =>
                    this.props.history.push(
                      `/violenciaGenero/${caso._id}/agregarMedida/`
                    )
                  }
                >
                  Generar Documento
                </Button>
                <Divider type="vertical" />
                <Button
                  type="primary"
                  onClick={() =>
                    this.mostrarModalUploader(!this.state.visibleModalUploader)
                  }
                >
                  <Icons.UploadOutlined /> Subir PDF
                </Button>
                <Divider type="vertical" />
                <Button
                  type="danger"
                  icon={<Icons.DeleteOutlined />}
                  onClick={() => this.onDelete(caso._id)}
                >
                  Eliminar Caso
                </Button>
                <Divider type="vertical" />
                <Button
                  type="primary"
                  icon={<Icons.PrinterOutlined />}
                  onClick={() => this.onImprimir(caso)}
                >
                  Imprimir Caso
                </Button>
              </Col>
            </Row>
          </div>
        ) : null}
        {this.state.editarAgresor ? (
          <FormPersona
            className="formularios"
            onSubmit={this.onFinishEditarAgresor}
            onAnterior={() => this.props.history.goBack()}
            persona={this.state.agresor}
            onFinish={this.onFinishEditarAgresor}
            requiereDNI={false}
          />
        ) : null}
        {this.state.editarPersona ? (
          <FormPersona
            className="formularios"
            onSubmit={this.onFinishEditarPersona}
            onAnterior={() => this.props.history.goBack()}
            persona={this.state.persona}
            onFinish={this.onFinishEditarPersona}
            requiereDNI={false}
          />
        ) : null}
      </div>
    );
  }
}

export default withApollo(VerCaso);
